import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiMail, FiPhone, FiMapPin, FiInstagram, FiFacebook, FiTwitter } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-red-950 text-white/80 py-16 border-t-4 border-blue-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          
          <div className="col-span-1 md:col-span-1">
            <div className="mb-6 flex items-center gap-3">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvcG5n/9aa18ac21ab89f27a1e775c23fc1c8fe.png" 
                alt="All Star Epoxy Logo" 
                className="w-12 h-12 object-contain drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]"
              />
              <span className="font-black text-xl tracking-tight text-white">
                All Star Epoxy
              </span>
            </div>
            <p className="text-sm leading-relaxed mb-6 text-red-100">
              Premium epoxy flooring solutions engineered for extreme durability and stunning aesthetics. Specializing in garages and commercial warehouses.
            </p>
            <div className="flex gap-4">
              <a href="#" className="hover:text-blue-400 transition-colors"><SafeIcon icon={FiInstagram} className="text-xl" /></a>
              <a href="#" className="hover:text-blue-400 transition-colors"><SafeIcon icon={FiFacebook} className="text-xl" /></a>
              <a href="#" className="hover:text-blue-400 transition-colors"><SafeIcon icon={FiTwitter} className="text-xl" /></a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold mb-6 tracking-wide">Quick Links</h4>
            <ul className="space-y-3 text-sm">
              <li><NavLink to="/" className="hover:text-blue-300 transition-colors">Home</NavLink></li>
              <li><NavLink to="/services" className="hover:text-blue-300 transition-colors">Our Services</NavLink></li>
              <li><NavLink to="/gallery" className="hover:text-blue-300 transition-colors">Project Gallery</NavLink></li>
              <li><NavLink to="/about" className="hover:text-blue-300 transition-colors">About Us</NavLink></li>
              <li><NavLink to="/contact" className="hover:text-blue-300 transition-colors">Contact</NavLink></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-6 tracking-wide">Our Services</h4>
            <ul className="space-y-3 text-sm text-red-100">
              <li>Residential Garages</li>
              <li>Commercial Warehouses</li>
              <li>Metallic Epoxy Finishes</li>
              <li>Flake Floor Systems</li>
              <li>Concrete Polishing</li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-6 tracking-wide">Contact Us</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiMapPin} className="text-blue-400 mt-1 flex-shrink-0" />
                <span className="text-red-100">3400 Bayview Dr,<br />Fort Lauderdale, FL 33306</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiPhone} className="text-blue-400 flex-shrink-0" />
                <a href="tel:9543285964" className="hover:text-blue-300 transition-colors text-red-100">(954) 328-5964</a>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiMail} className="text-blue-400 flex-shrink-0" />
                <a href="mailto:info@allstarepoxy.com" className="hover:text-blue-300 transition-colors text-red-100">info@allstarepoxy.com</a>
              </li>
            </ul>
          </div>

        </div>

        <div className="mt-16 pt-8 border-t border-red-900/50 text-sm text-center flex flex-col md:flex-row justify-between items-center gap-4 text-red-200">
          <p>&copy; {new Date().getFullYear()} All Star Epoxy. All rights reserved.</p>
          <div className="flex gap-4">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;